import nfetch from "@/utils/events/nfetch";

export default class FeatureFlagService {
    protected controllerName = "FeatureFlag";

    public isEnabled(featureFlag: string): Promise<Response> {
        return nfetch(`/${this.controllerName}/IsEnabled?featureFlag=${featureFlag}`, {
            credentials: "same-origin",
        });
    }

    public list(): Promise<Response> {
        return nfetch(`/${this.controllerName}/List`, {
            credentials: "same-origin",
        });
    }
}
